
let protocol = "http"
export const ApiProfile = {
    Dev: `${protocol}://172.20.1.177:8080/qms/`,
    Test: '',
    UAT: `${protocol}://172.20.1.217:8080/qms/`,
    Prod: 'https://corpapps.rabbitandtortoise.com/qms/'
}

export const getActivProfile = (profile) => {
    switch (profile) {
        case 'Dev': return (ApiProfile.Dev);
        case 'Test': return (ApiProfile.Test);
        case 'UAT': return (ApiProfile.UAT);
        case 'Prod': return (ApiProfile.Prod);
        default: return (ApiProfile.UAT);
    }
}


//OLD UAT LINK http://3.13.184.127:8080/qms/